<template>
  <div id="app">
         <div class="container-fluid" style="background:#fff;">
    <div class="container" style="padding-left:0px;">
    <nav class="navbar navbar-expand-lg " style="padding-left:0px;">
      <div class="collapse navbar-collapse" >
          <a class="navbar-brand" href="https://www.lefisc.com.br"> <img src="https://www.lefisc.com.br/imagens/logoOriginal.jpg" style="width:103;height:23px;"></a>
          <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
          <li  class="nav-item active" >
            <span></span>
              <a style="font-size: 20px!important; font-weight: 600!important;color: #000; padding-left: 10px!important;" 
              class="nav-link" href="https://www.lefisc.com.br/calculos"> Cálculos Trabalhistas</a>
          </li>
          </ul>
      </div>
    </nav>
    </div>
    </div> 
    <br>
      <transition name="transicao-pagina">
        <router-view/>
    </transition>
  </div>
</template>

<script>

export default {
  components: {
   
  },
  name: 'App',
  mounted(){
    
  }
}
</script>

<style>
div.container {
       max-width: 1275px;
}

.textoBloco1{
  color: #383838; 
  font-style: italic;
  font-weight: bold;
  height: 70px;
  font-size:19px;margin-top: 25px;
}
html {
  scroll-behavior: smooth;
}
.collapse li span{
  position: absolute;
  height: 22px;
  width: 0.5px;
  border:1px solid rgb(100, 100, 100);
  top:20px;
  left:110px;
}
 div.padrao{
  width: 200px;
  height: 180px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000029;
  cursor: pointer;
}
div.padrao:hover .bolha img{
      transform: scaleY(-1.2);
}
.padrao .ajus{
  display: flex;  
  flex-direction: column;
  align-items: center;
}
.padrao .bolha{
  width: 50px;
  height: 50px;
  border-radius: 50px;
  background: #F7B733;
  position: relative;
  z-index: 3;
  display: flex;
    justify-content: center;
    align-items: center;
}
.padrao .bolha img{
  width: 30px;
}
.padrao div.rodape{
  background: #EEEEEE;
    height: 45px;
    position: relative;
    top: -25px;
    z-index: 1;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
}
input{
  height: 41px;
}
.transicao-pagina-enter {
  opacity: 0;
}

.transicao-pagina-enter-to {
  opacity: 1;
}

.transicao-pagina-enter-active {
  transition: opacity 0.5s;
}

.transicao-pagina-leave {
  opacity: 0;
}

.transicao-pagina-leave-to {
  opacity: 1;
}

.transicao-pagina-leave-active {
  transition: opacity 0.5s;
}

.tela-enter {
  transform: translateX(-50%);
}

.tela-enter-to {
  transform: translateX(0);
}

.tela-leave {
  transform: translateX(0);
}

.tela-leave-to {
  transform: translateX(100%);
}

.tela-enter-active {
  transition: all 0.5s;
}
html, body {height:100%;}
#app {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; 
    min-height:100%;
  position:relative;

}
.rowBloco{
 top: -70px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  min-height: 200px;
  
}
.rowBloco > div {
  flex: 1 1 calc(25% - 20px); /* até 4 por linha */
  max-width: calc(25% - 20px); /* garante no máximo 4 por linha */
  min-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue